export default function Page404() {
    return (
        <section class="py-5">
            <div class="d-flex justify-content-center 
                    align-items-center flex-column 
                    text-center w-100">
                <div class="bg_img w-50">
                </div>
                <div>
                    <p class="display-4">Aradığınız sayfa Bulunamadı.</p>
                    <p>Aradığınız sayfadan emin olun ve tekrar deneyiniz...</p>
                    <a href="/"
                        class="text-white text-decoration-none px-4 py-3 
                        bg-success d-inline-block mt-2 rounded">
                        Anasayfaya dön
                    </a>
                </div>
            </div>
        </section>
    )
}   